/**
 * Skogstad Sport – nedtelling på lanseringssiden
 * ---------------------------------------------------------------------------
 * Seksjonen: sections/skogstad-nedtelling.liquid
 * Stilene:   assets/skogstad-lansering.css
 *
 * Skriptet gjør én ting: skriver fire tall inn i en liste som Liquid allerede
 * har rendret ferdig. Uten skriptet står nedtellingen skjult og den
 * serverrendrede reservelinja («Lanseres 24. september») står igjen –
 * derfor er siden aldri tom eller halvveis, den er bare roligere.
 *
 * ---------------------------------------------------------------------------
 * HVORFOR MÅLTIDSPUNKTET HAR EKSPLISITT TIDSSONE
 *
 * `new Date('2026-09-24T09:00')` uten sone tolkes som klokka ti HOS KUNDEN.
 * En kunde i London ville da sett nedtellingen treffe null en time før noe
 * skjedde. Liquid skriver derfor ut butikkens faktiske UTC-forskyvning på
 * rendringstidspunktet, og strengen blir «2026-09-24T09:00:00+0200» – det
 * samme øyeblikket for alle, uansett hvor de står.
 *
 * ---------------------------------------------------------------------------
 * HVORFOR setInterval OG IKKE requestAnimationFrame
 *
 * Motsatt av hero-karusellen, som har en CSS-animasjon å holde i takt med.
 * Her finnes ingen annen klokke å lyve for, og oppløsningen vi trenger er ett
 * sekund. rAF ville kjørt seksti ganger i sekundet for å skrive det samme
 * tallet på nytt 59 av dem.
 *
 * Intervallet stanser når fanen ikke er synlig, og leser klokka på nytt når
 * den kommer tilbake. En telefon som har ligget i lomma i to timer skal vise
 * riktig tall med en gang, ikke telle seg innpå.
 *
 * ---------------------------------------------------------------------------
 * NÅR KLOKKA TREFFER NULL SKJER DET INGENTING AUTOMATISK
 *
 * Bevisst. Siden bytter fra teaser til live når noen skrur av teasermodus i
 * temaeditoren, ikke når et tall når null. Et skript som avslørte kolleksjonen
 * av seg selv ville gjort klokkeslettet i et tekstfelt til den faktiske
 * lanseringen – og da ville en skrivefeil vært en publisering. Nedtellingen
 * stopper på null og sier «Nå er vi i gang», resten er et menneskes valg.
 */

(function () {
  'use strict';

  var VELGER = '[data-skogstad-nedtelling]';

  function tosifret(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function Nedtelling(rot) {
    this.rot = rot;
    this.mal = new Date(rot.getAttribute('data-maal')).getTime();
    this.reserve = document.getElementById(rot.getAttribute('data-reserve'));
    this.felt = {
      dager: rot.querySelector('[data-ledd="dager"]'),
      timer: rot.querySelector('[data-ledd="timer"]'),
      minutter: rot.querySelector('[data-ledd="minutter"]'),
      sekunder: rot.querySelector('[data-ledd="sekunder"]')
    };
    this.ferdigtekst = rot.getAttribute('data-ferdigtekst') || '';
    this.timer = null;

    // Ugyldig dato – f.eks. et tomt eller feilskrevet felt i editoren. Da lar
    // vi den serverrendrede linja stå og rører ingenting.
    if (isNaN(this.mal)) return;

    this.rot.hidden = false;
    if (this.reserve) this.reserve.hidden = true;

    this.tegn();
    this.start();

    document.addEventListener('visibilitychange', this.synlighet.bind(this));
  }

  Nedtelling.prototype.start = function () {
    if (this.timer) return;
    this.timer = window.setInterval(this.tegn.bind(this), 1000);
  };

  Nedtelling.prototype.stopp = function () {
    window.clearInterval(this.timer);
    this.timer = null;
  };

  Nedtelling.prototype.synlighet = function () {
    if (document.hidden) {
      this.stopp();
    } else {
      this.tegn();
      this.start();
    }
  };

  Nedtelling.prototype.tegn = function () {
    var igjen = this.mal - Date.now();

    if (igjen <= 0) {
      this.stopp();
      if (this.ferdigtekst) {
        this.rot.innerHTML = '';
        this.rot.textContent = this.ferdigtekst;
      }
      return;
    }

    var sekunder = Math.floor(igjen / 1000);
    var dager = Math.floor(sekunder / 86400);
    var timer = Math.floor((sekunder % 86400) / 3600);
    var minutter = Math.floor((sekunder % 3600) / 60);

    if (this.felt.dager) this.felt.dager.textContent = String(dager);
    if (this.felt.timer) this.felt.timer.textContent = tosifret(timer);
    if (this.felt.minutter) this.felt.minutter.textContent = tosifret(minutter);
    if (this.felt.sekunder) this.felt.sekunder.textContent = tosifret(sekunder % 60);
  };

  function start(rot) {
    if (rot.dataset.skogstadNedtellingKlar) return;
    rot.dataset.skogstadNedtellingKlar = '1';
    new Nedtelling(rot);
  }

  function startAlle(omrade) {
    (omrade || document).querySelectorAll(VELGER).forEach(start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      startAlle();
    });
  } else {
    startAlle();
  }

  // Temaeditoren bygger seksjonen på nytt ved hver innstillingsendring. Uten
  // dette ville nedtellingen stått død så snart redaktøren rørte et felt.
  document.addEventListener('shopify:section:load', function (e) {
    startAlle(e.target);
  });
})();
